/**
 * Configurație pentru ofertele promoționale
 *
 * Adaugă aici offer_id-urile ofertelor care trebuie evidențiate
 *
 * Structura:
 * - badge: textul afișat pe badge (ex: "OFERTA SĂRBĂTORI", "BLACK FRIDAY") - opțional
 * - infoTooltip: text afișat pe iconița info lângă "Preț FIX" - opțional
 * - priority: ordinea de afișare (1 = primul, 2 = al doilea, etc.)
 * - displayDuration: durata afișată (override pentru duration din API) - opțional
 */

// =====================
// Override-uri de afișare (nu afectează sortarea/badge-urile)
// =====================
export const offerOverrides = {
   "3e188621-5c28-f111-8342-000d3a44a1d4": { displayDuration: 15 },
   "08cc1f34-5b28-f111-8341-6045bd980ab7": { displayDuration: 15 },
};

// =====================
// PF (Persoană Fizică)
// =====================
const promotedOffersPF = {};

// =====================
// PJ (Persoană Juridică) - Nova Martie B2B-S
// =====================
const promotedOffersPJ = {};

// =====================
// Export config combinat
// =====================
export const promotedOffers = {
   ...promotedOffersPF,
   ...promotedOffersPJ
};

/**
 * Verifică dacă o ofertă este promovată
 * @param {number|string} offerId - ID-ul ofertei
 * @returns {boolean}
 */
export const isOfferPromoted = (offerId) => {
   return Object.prototype.hasOwnProperty.call(promotedOffers, offerId);
};

/**
 * Obține configurația promoției pentru o ofertă
 * @param {number|string} offerId - ID-ul ofertei
 * @returns {object|null}
 */
export const getPromotionConfig = (offerId) => {
   return promotedOffers[offerId] || null;
};

/**
 * Obține override-urile de afișare pentru o ofertă (ex: displayDuration)
 * @param {number|string} offerId - ID-ul ofertei
 * @returns {object|null}
 */
export const getOfferOverrides = (offerId) => {
   return offerOverrides[offerId] || null;
};

/**
 * Sortează ofertele cu cele promovate primele
 * @param {array} offers - Array de oferte
 * @returns {array} - Array sortat
 */
export const sortOffersWithPromotedFirst = (offers) => {
   if (!offers || !Array.isArray(offers)) return offers;

   return [...offers].sort((a, b) => {
      const aPromo = promotedOffers[a.offer_id];
      const bPromo = promotedOffers[b.offer_id];

      // Ofertele promovate primele
      if (aPromo && !bPromo) return -1;
      if (!aPromo && bPromo) return 1;

      // Între ofertele promovate, sortează după prioritate
      if (aPromo && bPromo) {
         return (aPromo.priority || 99) - (bPromo.priority || 99);
      }

      // Ofertele nepromovate se sortează după durată
      return a.duration - b.duration;
   });
};